import type { MenuModel } from '@/interfaces/model/menu.strapi.model';
import type { Menu, NavItem, NavButton, MenuItemSection } from '@/interfaces/strapi';
import { MenuOptionTypeEnum } from '@/enums/menuOptionType.enum';

function assertInternalPath(obj: any): string {
	const path: unknown = obj?.url;
	if (typeof path !== 'string' || !path.length) {
		console.warn('Menu item sin page.path (todos deben ser internos):', obj?.id ?? obj);
		return '#';
	}
	return path.startsWith('/') ? path : `/${path}`;
}

export const menuMapper = ({ MainMenuItems }: MenuModel): Menu => {
	const mappedNavItems: NavItem[] = [];
	const mappedNavButtons: NavButton[] = [];

	(MainMenuItems ?? []).forEach((section: any) => {
		switch (section.__component) {
			case MenuOptionTypeEnum.DROPDOWN: {
				const mappedOptions: MenuItemSection[] = (section.menu_options ?? []).map((option: any) => ({
					id: option.id,
					heading: option.heading,
					links: (option.links ?? []).map((link: any) => {
						const to = assertInternalPath(link);
						return {
							id: link.id,
							name: link.label ?? link.page?.menuLabel ?? link.page?.title ?? '—',
							icon: link.icon ?? '',
							description: link.description ?? '',
							url: link.url,
							externalUrl: link.external_url,
							openInNewTab: link.openInNewTab,
							isExternal: link.link_type === 'external',
						};
					}),
				}));

				mappedNavItems.push({
					name: section.title ?? '',
					icon: section.icon ?? '',
					sections: mappedOptions,
				});
				break;
			}

			case MenuOptionTypeEnum.ITEM_LINK: {
				const to = assertInternalPath(section);
				mappedNavItems.push({
					name: section.label ?? section.menuLabel ?? section.title ?? '',
					icon: section.icon ?? '',
					url: to,
				});
				break;
			}

			case MenuOptionTypeEnum.BUTTON: {
				if (section.page?.path) {
					const to = assertInternalPath(section);
					mappedNavButtons.push({
						name: section.text ?? '',
						url: to,
						type: section.type,
					});
				} else if (section.url && section.type) {
					mappedNavButtons.push({
						name: section.text ?? '',
						url: section.url,
						type: section.type,
					});
				}
				break;
			}

			default: {
				console.warn('Unknown menu component', section.__component);
				break;
			}
		}
	});

	return {
		navItems: mappedNavItems,
		buttons: mappedNavButtons,
	};
};
